import React from "react"
import { Table } from "reactstrap"

function DataList({ infos }) {
  return (
    <Table className="table">
      <tbody>
        {infos
          .filter(data => data.value !== "" && data.value)
          .map((data, i) => (
            <tr key={`data-${i}`}>
              <th>{data.label}</th>
              <td style={{ wordBreak: "break-all" }}>{data.value}</td>
            </tr>
          ))}
      </tbody>
    </Table>
  )
}

export default DataList
